export enum AccountUrls {
  myAccount = 'https://portal.office.com/account/#personalinfo',
  help = 'https://ltl-solutions.xpo.com/help-center/home/',
  privacyPolicy = 'https://www.xpo.com/privacy-policy/',
  switchApiUrl = 'https://switch-sandbox.xpoapi.com/users/',
  pictureUrl = '/picture?size=medium',
}
